export default function Testimonials() {
  return (
    <section className="py-40 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="relative">
          <div className="absolute -top-16 left-0 w-40 h-40 opacity-10">
            <svg viewBox="0 0 100 100" className="w-full h-full">
              <path d="M20,50 Q30,20 50,30 T80,50" stroke="currentColor" fill="none" strokeWidth="2" className="text-gray-900"/>
              <path d="M15,60 Q25,35 45,40 T75,60" stroke="currentColor" fill="none" strokeWidth="2" className="text-gray-900"/>
            </svg>
          </div>

          <div className="bg-[#0A0A0A] rounded-[40px] overflow-hidden grid grid-cols-1 lg:grid-cols-3">
            <div className="relative lg:col-span-1 h-full min-h-[600px]">
              <div className="absolute -top-8 left-0 right-0 bottom-0 lg:relative lg:top-0">
                <img
                  src="https://public.readdy.ai/ai/img_res/904bdb6217db546c580e8a5147d01e85.jpg"
                  alt="Cliente satisfecho"
                  className="w-full h-full object-cover object-top rounded-3xl"
                />
              </div>
            </div>

            <div className="lg:col-span-2 p-20 flex flex-col justify-center">
              <div className="text-[#F5E6D3] text-8xl mb-10 font-serif">"</div>
              
              <p className="text-white text-3xl leading-relaxed mb-16" style={{ lineHeight: '1.6' }}>
                El trabajo de enmarcación superó mis expectativas. Cada detalle fue cuidado con 
                profesionalismo y el resultado es una obra de arte en sí misma. La atención 
                personalizada y el conocimiento técnico hacen de Hollywood el mejor lugar para 
                enmarcar tus recuerdos más preciados.
              </p>
              
              <div className="mb-10">
                <p className="text-white text-2xl font-medium">María González</p>
                <p className="text-white text-lg opacity-80">Cliente desde 2020</p>
              </div>
              
              <div>
                <a
                  href="#contacto"
                  className="inline-block bg-[#F4C4C4] text-gray-900 px-10 py-4 rounded-full text-base font-medium hover:bg-[#F0B0B0] transition-colors cursor-pointer whitespace-nowrap"
                >
                  Ver más testimonios
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
